<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19knnmR/tc-custom/9781611176117.jpg?1729034158384" alt="This image is the cover for the book Untying the Moon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Untying the Moon
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman’s journey of self-discovery takes her across the coastal South and on to Alaska in this “beautifully written” novel (<i>Foreword Reviews</i>).</b><br/><br/> A child of the South Carolina lowcountry, Bailey Martin is in perpetual motion. A marine biologist by training and an artist by nature, she is a woman of contradictions: a free-spirited adventurer who is at the same time deeply committed to her family and the environment. Restless and troubled, Bailey sets out in her ‘67 Skylark convertible, from Manhattan down the eastern seaboard, from coastal Carolina to the Alaskan wilderness and back again, all in search of the embrace of love and—finally—of home.<br/><br/> Along the way, Bailey connects with some of the most important people and places in her life. She visits her fisherman father and falls in love with a troubled Vietnam veteran; she reflects on the beauty of nature, the devastations of oil spills and violent storms, and her own past.<br/><br/> Set in the 1980s, <i>Untying the Moon</i> explores the redemptive powers of nature, creation, and storytelling itself. With prose that ebbs and flows from the lyrical and lush to the staccato and sparse, <i>Untying the Moon</i> is rich with classical allusions and regional folklore, the beauty of its settings, a diverse cast of characters, and all the mystery and magic of fate.<br/><br/><b>Foreword by <i>New York Times</i> bestselling author Pat Conroy</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Malphrus, Pat Conroy
      </h2>
      
      <p class="authorDescription body article"><P>Ellen Malphrus lives and writes in her native Carolina lowcountry and southwest Montana. Her fiction, poetry, and essays have appeared in Southern Literary Journal, Review of Contemporary Fiction, William and Mary Review, Georgia Poetry Review, Haight Ashbury Literary Journal, and the anthology Essence of Beaufort and the Lowcountry. She was a student of James Dickey's and teaches at the University of South Carolina Beaufort.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6518f1b5